import Service from '@ember/service';

export default class StringsService extends Service {}
